import { solutionModelModule } from '../../../../shared/app/models/solution';

export const solutionsServiceModule = angular
  .module('Q.services.solutions-service', [solutionModelModule])

  .factory('solutionsService', function (Solution) {
    return {
      get: get,
      create,
    };

    function _replaceType(type) {
      return type.replace(/Challenge$/, 'Solution');
    }

    function get(challenge, assessmentResult) {
      if (!challenge || !assessmentResult) return null;
      const type = _replaceType(challenge.$type);
      const sol = Solution.filter({
        $type: type,
        challengeId: challenge.id,
        assessmentResultId: assessmentResult.id,
      });
      return sol[0];
    }

    function create(challenge, assessmentResult, language) {
      const type = _replaceType(challenge.$type);
      return Solution.createWithFetch(
        {
          $type: type,
          challengeId: challenge.id,
          assessmentResultId: assessmentResult.id,
          language: language,
        },
        {
          params: {
            // re-include challenge to get missing data
            includes: ['challenge'],
          },
        },
      );
    }
  });
